import Modal from "../../../components/Modal";
import { TextInput } from "../../../components/TextInput";
import { Button } from "../../../components/Button";
import { useState, useEffect, useId } from "react";
import { api } from "../../../services/api";
import { ShowToast } from "../../../services/toast";

export default function RenameFileModal({ isOpen, onClose, file, onSuccess }: { isOpen: boolean, onClose: () => void, file: any, onSuccess: () => void }) {
    const [form, setForm] = useState<any>({ name: file.file_name });
    const [saving, setSaving] = useState(false);
    const fileNameInputId = useId();
    
    const handleRename = () => {
        setSaving(true);
        api.renameSalesAidFile(file.id, form).then((res) => {
            if (res.status === 200) {
                ShowToast({
                    message: "File renamed successfully",
                    type: "success"
                });
                onSuccess();
            } else {
                ShowToast({
                    message: "Failed to rename file",
                    type: "error"
                });
            }
            setSaving(false);
        }).catch((err) => {
            setSaving(false);
            ShowToast({
                message: "Failed to rename file",
                type: "error"
            });
        });
    }


    useEffect(() => {
        if (isOpen) {
            setForm({ name: file.file_name });
        }
    }, [file, isOpen]);

    return (
        <Modal
            contentClassName="!px-0 [&_.title]:!text-[#444]"
            title="Rename Document"
            isOpen={isOpen}
            handleModal={onClose}
        >
            <div className="flex flex-col gap-4 px-5 mt-4">
                <div className="flex flex-col gap-2.5">
                    <label htmlFor={fileNameInputId} className="uppercase text-sm font-semibold text-gray-701">File Name</label>
                    <TextInput id={fileNameInputId} className="!bg-gray-100 !border-0 !rounded-md !h-9 !p-2.5" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                </div>
                <div className="flex justify-end mt-10 gap-2.5">
                    <Button variant="primary" onClick={onClose} disabled={saving} className="!rounded-full !text-black !w-24 hover:!opacity-80 !py-2.5 !bg-gray-201">Cancel</Button>
                    <Button variant="primary" onClick={handleRename} loading={saving} className="!rounded-full !min-w-24 !py-2.5">Save</Button>
                </div>
            </div>
        </Modal>
    )
    }